import { render, staticRenderFns } from "./CookieboxPage.vue?vue&type=template&id=4c958201&"
import script from "./CookieboxPage.vue?vue&type=script&lang=ts&"
export * from "./CookieboxPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports